import { isNil } from 'ramda';
import useDHFlags from '../useDHFlags';

/**
 * List all flags created inside of Gitlab
 * @see https://gitlab.dathuis.nl/dh/umbrella-widget/-/feature_flags
 */
export type Flag = 'multi-app-trigger';

const useDHFlag = (flag: Flag): boolean => {
  const activeFlags = useDHFlags();
  const foundFlag = activeFlags.find(({ name }) => name === flag);

  return !isNil(foundFlag);
};

export default useDHFlag;
